import { render, staticRenderFns } from "./TrainingItemSingleInfos.vue?vue&type=template&id=31fe7239&functional=true&"
import script from "./TrainingItemSingleInfos.vue?vue&type=script&lang=js&"
export * from "./TrainingItemSingleInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports